const dialog = {
  title: "Dialog",
  actions: [],
  modal: false,
  open: false,
};

export default dialog;



// WEBPACK FOOTER //
// ./app/data/dialog.js